import {connect} from "react-redux";
import {css, Theme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {flex, flexDirection, p, ph, position, pv, w100, zIndex} from "@pg-design/helpers-css";
import {ArrowIcon} from "@pg-design/icons-module";
import {Picture} from "@pg-design/picture-module";
import {Text} from "@pg-design/text-module";
import {form, FormActions, IFormProps} from "@pg-mono/form";
import {useUserDevice} from "@pg-mono/user-device";

import {IRPStore} from "../../app/rp_reducer";
import {IMainImage} from "../../offer/detail/components/property_list/OfferDetailPropertyList";
import {getThumbnailLink} from "../../utils/get_thumbnail_link";
import {IValueLabel} from "../../variables/types/IValueLabel";
import {IPropertyConfiguratorSearchFiltersFormValues, propertyConfiguratorSearchFormFields} from "../reducers/property_configurator_reducer";
import {PropertyConfiguratorSearchFormValuesType} from "../types/PropertyConfiguratorSearchFormValuesType";
import {FiltersInfoBar} from "./FiltersInfoBar";

interface IOwnProps {
    images: IMainImage | undefined;
    mainImageUrl: string | null | undefined;
    handleBackClick: () => void;
    name: string;
    address: string;
    vendorLogo: string | undefined;
    onEditClick: (value: boolean) => void;
}

interface IStateProps {
    formValues: PropertyConfiguratorSearchFormValuesType;
    propertyQuarters: IValueLabel[] | undefined;
}

interface IActionsProps {
    formActions: FormActions<Record<keyof typeof propertyConfiguratorSearchFormFields, unknown>>;
}

interface IProps extends IStateProps, IActionsProps, IFormProps<IPropertyConfiguratorSearchFiltersFormValues>, IOwnProps {}

export const OfferHeaderC = (props: IProps) => {
    const {isMobile} = useUserDevice();

    const mainImageMobile = getThumbnailLink(props.mainImageUrl, 760, 428) ?? props.images?.m_img_760x428;
    const mainImageDesktop = getThumbnailLink(props.mainImageUrl, 1500) ?? props.images?.m_img_1500;

    return (
        <>
            {isMobile && <FiltersInfoBar {...props} />}
            <div css={wrapper}>
                <Picture
                    alt="zdjęcie budynku z oferty"
                    sources={[
                        {minWidthPX: 0, src: mainImageMobile, height: 410, width: 360},
                        {minWidthPX: 1024, src: mainImageDesktop, height: 566, width: 1128}
                    ]}
                    css={mainImage}
                />
                <Button variant="none_secondary" css={backButton} iconLeft={ArrowIcon} onClick={props.handleBackClick}>
                    Powrót do lokalizacji
                </Button>
                <div css={lowerWrapper}>
                    <div css={[flex("flex-start"), flexDirection("column")]}>
                        <Text variant="headline_2" color="white">
                            {props.name}
                        </Text>
                        <Text variant="body_copy_0" color="white">
                            {props.address}
                        </Text>
                    </div>
                    <img src={props.vendorLogo} />
                </div>
            </div>
        </>
    );
};

function mapStateToProps(state: IRPStore): IStateProps {
    return {
        formValues: state.propertyConfigurator.formValues,
        propertyQuarters: state.variables.data?.property_quarters
    };
}

export const OfferHeader = connect(mapStateToProps)(form<IPropertyConfiguratorSearchFiltersFormValues, IProps>(OfferHeaderC));

const wrapper = (theme: Theme) => css`
    ${flex("flex-start", "space-between")};
    ${flexDirection("column")};
    ${ph(4)};
    ${pv(2)};
    ${w100};
    min-height: 566px;
    max-height: 566px;
    ${position("relative")};
    overflow: hidden;
    background: rgb(0, 0, 0);
    background: linear-gradient(0deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 20%, rgba(0, 0, 0, 0) 85%, rgba(0, 0, 0, 1) 100%);

    @media (max-width: ${theme.breakpoints.md}) {
        ${p(2)};
        min-height: 410px;
        max-height: 410px;
        align-self: center;
        width: 100vw;
    }
`;

const backButton = css`
    svg {
        filter: brightness(0) invert(1);
    }
    > span {
        color: white;
    }
`;

const lowerWrapper = css`
    ${flex("flex-end", "space-between")};
    ${w100};

    > img {
        max-width: 160px;
    }
`;

/**
 * `Picture` from `picture-module` renders a `position: relative` <picture> wrapper, so the image has to be positioned
 * through that wrapper - absolutely positioning the <img> alone would size it against a zero-width parent.
 */
const mainImage = (theme: Theme) => css`
    ${position("absolute")};
    ${w100};
    ${zIndex(-1)};
    height: 566px;
    top: 0;
    left: 0;

    img {
        ${w100};
        height: 100%;
        object-fit: cover;
    }

    @media (max-width: ${theme.breakpoints.md}) {
        height: 410px;
    }
`;
import {connect} from "react-redux";
import {css, Theme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {flex, flexDirection, p, ph, position, pv, w100, zIndex} from "@pg-design/helpers-css";
import {ArrowIcon} from "@pg-design/icons-module";
import {Picture} from "@pg-design/picture-module";
import {Text} from "@pg-design/text-module";
import {form, FormActions, IFormProps} from "@pg-mono/form";
import {useUserDevice} from "@pg-mono/user-device";

import {IRPStore} from "../../app/rp_reducer";
import {IMainImage} from "../../offer/detail/components/property_list/OfferDetailPropertyList";
import {getThumbnailLink} from "../../utils/get_thumbnail_link";
import {IValueLabel} from "../../variables/types/IValueLabel";
import {IPropertyConfiguratorSearchFiltersFormValues, propertyConfiguratorSearchFormFields} from "../reducers/property_configurator_reducer";
import {PropertyConfiguratorSearchFormValuesType} from "../types/PropertyConfiguratorSearchFormValuesType";
import {FiltersInfoBar} from "./FiltersInfoBar";

interface IOwnProps {
    images: IMainImage | undefined;
    mainImageUrl: string | null | undefined;
    handleBackClick: () => void;
    name: string;
    address: string;
    vendorLogo: string | undefined;
    onEditClick: (value: boolean) => void;
}

interface IStateProps {
    formValues: PropertyConfiguratorSearchFormValuesType;
    propertyQuarters: IValueLabel[] | undefined;
}

interface IActionsProps {
    formActions: FormActions<Record<keyof typeof propertyConfiguratorSearchFormFields, unknown>>;
}

interface IProps extends IStateProps, IActionsProps, IFormProps<IPropertyConfiguratorSearchFiltersFormValues>, IOwnProps {}

export const OfferHeaderC = (props: IProps) => {
    const {isMobile} = useUserDevice();

    const mainImageMobile = getThumbnailLink(props.mainImageUrl, 760, 428) ?? props.images?.m_img_760x428;
    const mainImageDesktop = getThumbnailLink(props.mainImageUrl, 1500) ?? props.images?.m_img_1500;

    return (
        <>
            {isMobile && <FiltersInfoBar {...props} />}
            <div css={wrapper}>
                <Picture
                    alt="zdjęcie budynku z oferty"
                    sources={[
                        {minWidthPX: 0, src: mainImageMobile, height: 410, width: 360},
                        {minWidthPX: 1024, src: mainImageDesktop, height: 566, width: 1128}
                    ]}
                    css={mainImage}
                />
                <Button variant="none_secondary" css={backButton} iconLeft={ArrowIcon} onClick={props.handleBackClick}>
                    Powrót do lokalizacji
                </Button>
                <div css={lowerWrapper}>
                    <div css={[flex("flex-start"), flexDirection("column")]}>
                        <Text variant="headline_2" color="white">
                            {props.name}
                        </Text>
                        <Text variant="body_copy_0" color="white">
                            {props.address}
                        </Text>
                    </div>
                    <img src={props.vendorLogo} />
                </div>
            </div>
        </>
    );
};

function mapStateToProps(state: IRPStore): IStateProps {
    return {
        formValues: state.propertyConfigurator.formValues,
        propertyQuarters: state.variables.data?.property_quarters
    };
}

export const OfferHeader = connect(mapStateToProps)(form<IPropertyConfiguratorSearchFiltersFormValues, IProps>(OfferHeaderC));

const wrapper = (theme: Theme) => css`
    ${flex("flex-start", "space-between")};
    ${flexDirection("column")};
    ${ph(4)};
    ${pv(2)};
    ${w100};
    min-height: 566px;
    max-height: 566px;
    ${position("relative")};
    overflow: hidden;
    background: rgb(0, 0, 0);
    background: linear-gradient(0deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 20%, rgba(0, 0, 0, 0) 85%, rgba(0, 0, 0, 1) 100%);

    @media (max-width: ${theme.breakpoints.md}) {
        ${p(2)};
        min-height: 410px;
        max-height: 410px;
        align-self: center;
        width: 100vw;
    }
`;

const backButton = css`
    svg {
        filter: brightness(0) invert(1);
    }
    > span {
        color: white;
    }
`;

const lowerWrapper = css`
    ${flex("flex-end", "space-between")};
    ${w100};

    > img {
        max-width: 160px;
    }
`;

/**
 * `Picture` from `picture-module` renders a `position: relative` <picture> wrapper, so the image has to be positioned
 * through that wrapper - absolutely positioning the <img> alone would size it against a zero-width parent.
 */
const mainImage = (theme: Theme) => css`
    ${position("absolute")};
    ${w100};
    ${zIndex(-1)};
    height: 566px;
    top: 0;
    left: 0;

    img {
        ${w100};
        height: 100%;
        object-fit: cover;
    }

    @media (max-width: ${theme.breakpoints.md}) {
        height: 410px;
    }
`;
